module.exports = __webpack_public_path__ + "static/media/Picture1.d676ec36.jpg";